

















































































































































































import { Component, Model, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import { CaseDashboard, CaseFilter } from "@/store/modules/types";
import { BPopover } from "bootstrap-vue";
import InputPopover from "@/components/InputPopover.vue";
import SelectPopover from "@/components/SelectPopover.vue";

@Component({
  components: {
    BPagination,
    BPopover,
    InputPopover,
    SelectPopover,
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("cases", ["dashboard"]),
    ...mapState("gaps", ["campaigns"]),
  },
})
export default class CasePager extends Vue {
  @Prop(Boolean) readonly rowsChecked!: Boolean;
  dashboard!: CaseDashboard;
  campaignId = "";
  filterId = 0;
  filters = Array<any>();
  showSaveFilter = false;
  get selectedFilter() {
    return this.filters.find((f) => f.id === this.filterId);
  }
  campaignChanged() {
    this.$store.commit("cases/SET_CAMPAIGN_FILTER", this.campaignId);
  }
  @Watch("filterId")
  filterChanged() {
    if (this.selectedFilter) {
      const filter = JSON.parse(this.selectedFilter.json) as CaseFilter;
      if (!filter.entityId) {
        filter.entityId = this.dashboard.filter.entityId;
      }
      this.campaignId = filter.campaignId;
      this.$store.commit("auth/SET_ENTITY", filter.entityId);
      this.$store.commit("cases/SET_FILTER", filter);
    }
  }
  setPageNumber(page: number) {
    this.$store.commit("cases/SET_PAGE_NUMBER", page);
  }
  setRowsPerPage(e) {
    const rowsPerPage: number = e.target.value;
    this.$store.commit("cases/SET_ROWS_PER_PAGE", rowsPerPage);
  }
  async getFilters() {
    try {
      this.filters = await this.$store.dispatch("cases/getCaseFilters");
      if (!this.dashboard.pageRows.length) {
        this.filterChanged();
      }
    } catch (error) {
      console.log(error);
    }
  }
  async saveFilter(name: string) {
    try {
      const { newFilterId } = await this.$store.dispatch(
        "cases/saveCaseFilter",
        name
      );
      this.filterId = newFilterId;
      this.getFilters();
    } catch (error) {
      console.log(error);
    }
  }
  async archiveFilter() {
    const { id, name } = this.selectedFilter;
    this.$modal.show("dialog", {
      title: "Remove filter '" + name + "'",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            try {
              await this.$store.dispatch("cases/archiveCaseFilter", id);
              this.$modal.hide("dialog");
              this.filterId = 0;
              this.getFilters();
            } catch (error) {
              console.log(error);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  clearFilter() {
    if (this.filterId === -1) {
      this.$store.commit("cases/RESET_FILTER", this.dashboard.filter.entityId);
    } else {
      this.filterId = -1;
    }
    this.campaignId = "";
  }
  mounted() {
    this.campaignId = this.dashboard.filter.campaignId;
    this.getFilters();
  }
}
